export default "__VITE_ASSET__BwR4lOkQ__"